export default __webpack_public_path__ + "static/top-8cef950ecef637f5983b75bf987f5939.png";